import { Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DISABILITY_STATUS } from 'Enum/personalDetails';
import { useDictionary, useIsDesktop } from 'Hooks';
import { addImposterToUrl, downloadFile } from 'Utils';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { api } from 'API';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IDisabilityCertificateLinks {
  disabilityPercent: string | undefined;
  disabilityStatus: string | undefined;
}

export const DisabilityCertificateLinks = ({
  disabilityPercent,
  disabilityStatus,
}: IDisabilityCertificateLinks) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  const DisabilityConfirmationWithDetailsId = 6,
    DisabilityConfirmationId = 5;

  const exportToPdf = async (id: number) => {
    let response = await api.get(
      addImposterToUrl(`DisabilityConfirmations/${id}`, true)
    );
    if (response.status === HTTP_STATUS_CODES.OK)
      downloadFile(
        response.data.file,
        '.pdf',
        DisabilityConfirmationWithDetailsId === 6
          ? 'DisabilityConfirmationWithDetails'
          : 'DisabilityConfirmation'
      );
    else alert(Dictionary[DICTIONARY.TestMenu].errorCreatingFile);
  };

  return (
    <Stack
      bgcolor={'primary.shade_100'}
      border={'1px solid'}
      borderColor={'primary.shade_200'}
      borderRadius='8px'
      padding={isDesktop ? '16px 24px' : '12px 16px'}
      gap={'12px'}
    >
      <Typography variant={'body4'}>
        {disabilityPercent
          ? dictionary.disabilityInformation.disabilityStatsPercent +
            disabilityPercent
          : dictionary.noData}
      </Typography>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        justifyContent={'space-between'}
        gap={isDesktop ? 0 : '16px'}
      >
        <Stack
          direction='row'
          alignItems='center'
          textAlign='center'
          width={'auto'}
        >
          {/* <Avatar
            alt={''}
            src={PurpleOutlinedAlert}
            sx={{ width: '20px', height: '20px', marginRight: '7px' }}
          />
          <Stack direction={'row'} alignItems={'flex-end'} gap={'4px'}>
            <Link fontWeight={400} underline={'hover'}>
              <Typography variant={'body3'} tabIndex={0}>
                {dictionary.links.disabilityStatsInformation}
              </Typography>
            </Link>
            <DynamicArrow color={'blue'} rotate={90} />
          </Stack> */}
        </Stack>
        {(disabilityStatus === DISABILITY_STATUS.hasDisabilityApproval06 ||
          disabilityStatus === DISABILITY_STATUS.hasDisabilityApproval14) && (
          <Stack
            direction={'row'}
            gap={isDesktop ? '64px' : 0}
            justifyContent={'space-between'}
            width={'auto'}
          >
            <Link
              onClick={() => exportToPdf(DisabilityConfirmationWithDetailsId)}
              onKeyDown={onEnterOrEscapeKeyDown}
              tabIndex={0}
            >
              <Typography variant={'body6'} whiteSpace={'nowrap'}>
                {dictionary.links.detailedDisabilityCertificate}
              </Typography>
            </Link>
            <Link
              onClick={() => exportToPdf(DisabilityConfirmationId)}
              onKeyDown={onEnterOrEscapeKeyDown}
              tabIndex={0}
            >
              <Typography variant={'body6'}>
                {dictionary.links.disabilityCertificate}
              </Typography>
            </Link>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
